"use client";

import React from "react";
import { ThermometerSnowflake, Fan, Wrench, Activity, ShieldCheck, Cpu } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const expertiseData = [{
  title: "Instalace klimatizace",
  desc: "Precizní instalace vysoce účinných chladicích systémů navržených pro optimální regulaci klimatu a úsporu energie.",
  icon: ThermometerSnowflake
}, {
  title: "Instalace tepelných čerpadel",
  desc: "Pokročilá integrace tepelných čerpadel poskytující udržitelná, celoroční řešení vytápění a chlazení pro jakékoli prostředí.",
  icon: Fan
}, {
  title: "Servis a údržba HVAC",
  desc: "Komplexní servisní protokoly zajišťující špičkový výkon, spolehlivost a dlouhou životnost vašich klíčových zařízení.",
  icon: Wrench
}, {
  title: "Diagnostika a opravy",
  desc: "Rychlé a přesné řešení problémů a opravy s využitím špičkových diagnostických nástrojů a technických odborných znalostí.",
  icon: Activity
}, {
  title: "Preventivní údržba",
  desc: "Proaktivní plány údržby pečlivě navržené tak, aby předcházely nákladným poruchám a minimalizovaly provozní prostoje.",
  icon: ShieldCheck
}, {
  title: "Technická řešení na míru",
  desc: "Návrh a konstrukce HVAC systémů na míru, vytvořené speciálně pro komplexní komerční a průmyslové aplikace.",
  icon: Cpu
}];
export default function OurCoreExpertise() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="our-core-expertise" className="dark bg-background text-foreground py-24 md:py-32 relative overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.02]" style={{
      backgroundImage: 'linear-gradient(to right, #ffffff 1px, transparent 1px), linear-gradient(to bottom, #ffffff 1px, transparent 1px)',
      backgroundSize: '4rem 4rem'
    }}>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div ref={headerRef} className={`max-w-3xl mb-16 md:mb-24 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-sm font-mono text-primary mb-4 tracking-wider uppercase">
            
          </h2>
          <h3 className="text-4xl md:text-5xl font-bold text-foreground tracking-tight mb-6">
            Naše hlavní odbornost
          </h3>
          <p className="text-lg text-muted-foreground leading-relaxed max-w-2xl">
            Poskytujeme průmyslovou preciznost a moderní technická řešení pro komplexní výzvy v oblasti HVAC. Kombinujeme robustní spolehlivost s diagnostikou založenou na datech.
          </p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 transition-all duration-1000 delay-200 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {expertiseData.map((item, i) => <Card key={i} data-index={i} className="group relative overflow-hidden border-border/40 bg-card/30 backdrop-blur-md hover:border-primary transition-colors duration-500 min-h-[280px] flex flex-col justify-end rounded-xl">
              {}
              <div className="absolute inset-0 opacity-[0.04] pointer-events-none mix-blend-screen" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
          }} />

              {}
              <div className="absolute top-6 right-6 text-muted-foreground/20 group-hover:text-primary/40 transition-colors duration-500 transform group-hover:scale-110 group-hover:-rotate-3">
                <item.icon className="w-16 h-16" strokeWidth={0.75} />
              </div>

              {}
              <div className="absolute bottom-4 right-6 font-mono text-6xl font-black text-transparent group-hover:text-primary/[0.03] transition-colors duration-700 pointer-events-none select-none translate-y-4 group-hover:translate-y-0">
                {String(i + 1).padStart(2, '0')}
              </div>

              <CardHeader className="relative z-10 pb-2 pt-16">
                <CardTitle className="text-xl font-semibold text-foreground group-hover:text-primary transition-colors duration-300">
                  {item.title}
                </CardTitle>
              </CardHeader>
              
              <CardContent className="relative z-10 pb-8">
                <CardDescription className="text-muted-foreground text-base leading-relaxed">
                  {item.desc}
                </CardDescription>
              </CardContent>
              
              {}
              <div className="absolute bottom-0 left-0 h-1 w-0 bg-primary transition-all duration-500 group-hover:w-full opacity-50" />
            </Card>)}
        </div>
      </div>
    </section>;
}